import { List } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/layout/components/Page/Loading'
import { Item, MaterializedItem } from 'modules/processes/domain'

import { EmptyState } from './EmptyState'
import { MaterializedAction } from './_materializedAction'
import MaterializedTask, { ConfigItemComponent } from './_materializedTask'
import { useActionItems } from './useActionItems'
import { useMaterializeItemTasks } from './useTaskItems'

interface Props {
  items: Item[]
  materializedProcessId: number
  isCurrentStep: boolean
  materializedItems: MaterializedItem[] | undefined
  materializedProcessAccessId: number
}

const Items = ({
  isCurrentStep,
  materializedItems,
  materializedProcessId,
  items,
  materializedProcessAccessId,
}: Props) => {
  const hasMaterialisedItems = Boolean(materializedItems)

  const taskMaterializedItems = materializedItems?.filter(
    (materializedItem) => materializedItem.resourceType == 'Tasks::Task'
  )
  const taskIds = taskMaterializedItems?.flatMap(
    (materializedItem) => materializedItem.resourceId || [0] // as we have the skip in the query it will work fine
  )
  const { tasks, loading } = useMaterializeItemTasks({
    skip: !taskMaterializedItems?.length,
    variables: {
      ids: taskIds,
    },
  })

  const actionItems = useActionItems({
    items: materializedItems || [],
    accessId: materializedProcessAccessId,
  })

  if (loading) return <Loading />

  // when there are no items and no materialized items
  if (!materializedItems?.length && !items.length) return <EmptyState />

  return (
    <List>
      {hasMaterialisedItems &&
        materializedItems?.map((materializedItem) => {
          if (materializedItem.resourceType == 'Tasks::Task')
            return (
              <MaterializedTask
                key={materializedItem.id}
                isCurrentStep={isCurrentStep}
                materializedProcessId={materializedProcessId}
                materializedItem={materializedItem}
                task={tasks.find((task) => task.id == materializedItem.resourceId)}
              />
            )

          if (materializedItem.resourceType === 'Processes::MaterializedAction')
            return (
              <MaterializedAction
                key={materializedItem.id}
                materializedItem={materializedItem}
                isCurrentStep={isCurrentStep}
                actionItems={actionItems}
              />
            )
        })}
      {!hasMaterialisedItems &&
        items?.map((item) => <ConfigItemComponent key={item.id} item={item} />)}
    </List>
  )
}

export default observer(Items)
